import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { invalidateFor } from "@/lib/cache-registry";

export interface AttestMonthInput {
  year: number;
  month: number;
}

interface AttestedMonth {
  id: string;
  user_id: string;
  year: number;
  month: number;
  confirmed_at: string;
}

/** Attester innlogget brukers måned i én atomisk serveroperasjon. */
export function useCloseMonth() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ year, month }: AttestMonthInput): Promise<AttestedMonth> => {
      const { data, error } = await supabase.rpc("attest_month", {
        p_year: year,
        p_month: month,
      });
      if (error) throw error;
      return data as AttestedMonth;
    },
    onSuccess: async (confirmation) => {
      await invalidateFor(queryClient, "monthly_confirmations", {
        userId: confirmation.user_id,
      });
      toast.success("Måneden er lukket");
    },
    onError: (error) => {
      toast.error((error as Error).message || "Kunne ikke lukke måneden");
    },
  });
}
